// extracted by mini-css-extract-plugin
export var alternate = "_d-j";
export var black = "_d-6";
export var blue = "_d-f";
export var blueLight = "_d-e";
export var brand = "_d-8";
export var darkMode = "_d-b";
export var error = "_d-a";
export var gray = "_d-5";
export var grayBlue = "_d-d";
export var iconWrapper = "_d-3";
export var inactive = "_d-7";
export var indigo = "_d-g";
export var orange = "_d-i";
export var pink = "_d-h";
export var primary = "_d-0";
export var purple = "_d-9";
export var success = "_d-4";
export var warning = "_d-c";
export var white = "_d-1";
export var whiteSuccess = "_d-2";